import React from 'react';
import Picture from '@Theme/natucare/components/Picture/Picture';
import { itemPropTypes } from './ItemPropTypes';
import * as styles from './Item.module.scss';
const Item = ({
  heading,
  category,
  description,
  href,
  date,
  dateFormat,
  picture,
  isActive
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: `${styles.root} ${isActive ? styles.rootActive : ''}`
  }, picture && picture.src && /*#__PURE__*/React.createElement(Picture, {
    xs: {
      src: picture.src
    },
    pictureClassname: styles.rootPicture,
    imgClassname: styles.rootImage,
    alt: picture === null || picture === void 0 ? void 0 : picture.alt
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.rootContent
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.rootHeader
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.rootCategory
  }, category), /*#__PURE__*/React.createElement("time", {
    className: styles.rootDate,
    dateTime: dateFormat
  }, date.string)), /*#__PURE__*/React.createElement("h3", {
    className: styles.rootHeading
  }, /*#__PURE__*/React.createElement("a", {
    className: styles.rootLink,
    href: href
  }, heading)), /*#__PURE__*/React.createElement("p", {
    className: styles.rootText
  }, description)));
};
export default Item;